import React, { useState, useEffect } from 'react';
import { API_BASE } from '../config/apiConfig';

/**
 * Client Dashboard — landing page after onboarding.
 * Shows the client's AI layer statuses and quick actions.
 */
const ClientDashboard = ({ clientConfig }) => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!clientConfig?.client_id) return;
    fetch(`${API_BASE}/clients/${clientConfig.client_id}/status`)
      .then(r => r.ok ? r.json() : null)
      .then(setStatus)
      .catch(() => {});
  }, [clientConfig]);

  if (!clientConfig) return null;

  return (
    <div style={{ padding: '2rem' }}>
      <h2 style={{ marginBottom: '0.5rem' }}>📊 {clientConfig.company_name}</h2>
      <p style={{ color: '#666', marginBottom: '2rem' }}>
        Client ID: <code>{clientConfig.client_id}</code> &middot; Plan: {clientConfig.plan} &middot; Type: {clientConfig.tenant_type}
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.5rem', marginBottom: '2rem' }}>
        {[
          { label: 'Guardrails', icon: '🛡️', desc: 'Boundary Rules', status: status?.rag_status || 'pending' },
          { label: 'LLM', icon: '⚙️', desc: 'Operations BI', status: status?.genai_status || 'pending' },
          { label: 'Comm-AI', icon: '🐙', desc: 'Public Bridge', status: status?.agentic_status || 'pending' },
        ].map(layer => (
          <div key={layer.label} style={{
            background: '#fff', border: '1px solid #e0e0e0', borderRadius: '12px',
            padding: '1.5rem', textAlign: 'center',
          }}>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>{layer.icon}</div>
            <h3 style={{ margin: '0 0 0.25rem' }}>{layer.label}</h3>
            <p style={{ color: '#888', fontSize: '0.85rem', margin: '0 0 0.75rem' }}>{layer.desc}</p>
            <span style={{
              display: 'inline-block', padding: '4px 12px', borderRadius: '12px', fontSize: '0.8rem', fontWeight: 600,
              background: layer.status === 'indexed' || layer.status === 'configured' ? '#e8f5e9' : '#fff3e0',
              color: layer.status === 'indexed' || layer.status === 'configured' ? '#2e7d32' : '#e65100',
            }}>
              {layer.status}
            </span>
          </div>
        ))}
      </div>

      <div style={{ background: '#f8f9fa', borderRadius: '12px', padding: '1.5rem', border: '1px solid #e0e0e0' }}>
        <h3 style={{ marginTop: 0 }}>How It Works</h3>
        <p style={{ color: '#555', lineHeight: 1.6 }}>
          Use the sidebar menus to interact with your business data. Each menu is powered by your <strong>LLM</strong> layer
          and queries your private database through tenant-isolated SQL views. The <strong>Comm-AI</strong> menu handles
          all external communication — finding vendors, sending agreements via SignWell, and managing cross-tenant
          access requests through the MCP/A2A protocol.
        </p>
        <p style={{ color: '#555', lineHeight: 1.6 }}>
          Your data is private by default. Distributors or partners must request temporary read-only access through
          the A2A handshake — you can review and revoke grants anytime from <strong>Permission Logs</strong>.
        </p>
      </div>
    </div>
  );
};

export default ClientDashboard;
